export default __webpack_public_path__ + "static/media/logo-company-10.909c7db1.png";